import { Routes } from '@angular/router';
import { environment } from '../environments/default/environment';
import { AuthenticationGuard } from '../core-modules/auth/authentication.guard';
import { LoginComponent } from './authentication/login/login.component';
import { RegisterComponent } from './authentication/register/register.component';
import { RequestResetPasswordComponent } from './authentication/request-reset-password/request-reset-password.component';
import { SetMenuGuard } from '../core-modules/menu/setMenu.guard';
import { ResetPasswordComponent } from './authentication/reset-password/reset-password.component';
import { CompleteRegisterComponent } from './authentication/complete-register/complete-register.component';
import { PurpleLocalizationGuard } from '@purple-lib/purple-translations-core';
import { PurpleUserValidationGuard } from '@purple-lib/purple-users-core';
import { PurplePolicyInternalLinkPageComponent } from '@purple-lib/purple-policies-core';

let lan = localStorage.getItem('Language')?.replaceAll('"', "") ?? environment.DEFAULT_LANGUAGE;

export const routes: Routes = [
  {
    path: '',
    redirectTo: lan + '/login',
    pathMatch: 'full'
  },
  {
    path: 'payment-ok',
    redirectTo: lan + '/' + environment.CLIENT_ROUTE + '/products/true',
    pathMatch: 'full'
  },
  {
    path: 'payment-ko',
    redirectTo: lan + '/' + environment.CLIENT_ROUTE + '/products/false',
    pathMatch: 'full'
  },
  {
    path: ':cultureId',
    canActivate: [PurpleLocalizationGuard, PurpleUserValidationGuard],
    children: [
      {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full'
      },
      {
        path: 'login',
        component: LoginComponent,
        data: { menu: "login", mustBeLogged: false, showTabMenu: false },
        canActivate: [AuthenticationGuard, SetMenuGuard]
      },
      {
        path: 'register',
        component: RegisterComponent,
        data: { menu: "register", mustBeLogged: false, showTabMenu: false },
        canActivate: [AuthenticationGuard, SetMenuGuard],

      },
      {
        path: 'complete-registration',
        component: CompleteRegisterComponent,
        data: { mustBeLogged: false, showTabMenu: false },
        canActivate: [AuthenticationGuard]
      },
      {
        path: 'request-reset-password',
        component: RequestResetPasswordComponent,
        data: { menu: "request-reset-password", mustBeLogged: false, showTabMenu: false },
        canActivate: [AuthenticationGuard]
      },
      {
        path: 'reset-password',
        component: ResetPasswordComponent,
        data: { menu: "reset-password", mustBeLogged: false, showTabMenu: false },
        canActivate: [AuthenticationGuard]
      },
      {
        path: 'verify-account',
        redirectTo: 'login',
        pathMatch: 'full'
      },
      {
        path: environment.CLIENT_ROUTE,
        canActivate: [AuthenticationGuard],
        loadChildren: () => import('./purple-fit/user/purple-fit-user-routing').then(m => m.PURPLE_FIT_ROUTING),
        data: { mustBeLogged: true, showTabMenu: true },
      },
      {
        path: environment.CLIENT_ROUTE + '-trainer',
        canActivate: [AuthenticationGuard],
        loadChildren: () => import('./purple-fit/trainer/purple-fit-trainer-routing').then(m => m.PURPLE_FIT_TRAINER_ROUTING),
        data: { mustBeLogged: true, showTabMenu: true },
      },
      {
        path: 'policy-info',
        component: PurplePolicyInternalLinkPageComponent
      }
    ]
  },

];
